<script setup>
	import { ref, watch } from 'vue'
	import { setGoodTypeLabel, formatNumber } from '@/utils/utils.js'
	import { getProductAttr, addCart } from '@/api/product';
	import { storeToRefs } from 'pinia'
	import useStoreFun from '@/stores/index.js';
	const { useUserStore } = useStoreFun()
	const { userInfo } = storeToRefs(useUserStore)
	const props = defineProps({
		item: {
			default: {}
		}
	})
	const myEmit = defineEmits(['operation'])
	function itemClick(item) {
		myEmit('operation', 'goods', {
			item
		})
	}
	const isToken = ref(!!uni.getStorageSync('bingo-token'));
	function login() {
		uni.showToast({
			title: "请先登录",
			icon: "none"
		})
		setTimeout(() => {
			// #ifdef MP-WEIXIN
			uni.navigateTo({ url: '/pageA/login/login' })
			// #endif
			// #ifndef MP-WEIXIN
			uni.navigateTo({ url: '/pageA/login/bind' })
			// #endif
		}, 800)
	}
	// 获取规格
	const attrShow = ref(false);
	const productValue = ref([]);
	const productAttr = ref([]);
	const productSelect = ref(null);
	const attrNumber = ref(1);
	function getAddr(id) {
		isToken.value = !!uni.getStorageSync('bingo-token')
		if(!isToken.value) {
			login();
			return;
		}
		getProductAttr({ id: id }).then(res => {
			if(res.data.productValue.length == 1){
				addCart({
					productId: res.data.productValue[0].productId,
					productAttrUnique: res.data.productValue[0]?.id,
					cartNum: 1,
				}).then(() => {
					uni.showToast({
						title: "加入购物车成功",
						icon: "none"
					})
					const pages = getCurrentPages();
					let currentRoute = pages[pages.length - 1].route;
					if(currentRoute.indexOf("pages/cart/cart") > -1 ) {
						uni.$emit("cartOperate", null);
					}
				})
			}else{
				productValue.value = res.data.productValue;
				productAttr.value = res.data.productAttr;
				productSelect.value = productValue.value[0];
				attrShow.value = true;
			}
		})
	}
	function changeAttr(value, number) {
		attrShow.value = false;
	}
</script>

<template>
	<view class="item">
		<view class="name">
			<text class="label" v-if="item.productTags?.locationLeftTitle?.length>0" :style="{'background': setGoodTypeLabel(item.type)}">{{item.productTags.locationLeftTitle[0].tagName}}</text>
			<text class="name">{{item.name}}</text>
		</view>
		<view class="labels o-flex-r-s-c o-wrap" v-if="item.productTags?.locationUnderTitle?.length>0">
			<view class="tag" v-for="(item,index) in item.productTags.locationUnderTitle" :key="index"
			:style="{'background': item.backgroundColor, 'color': item.fontColor}">{{item.tagName}}</view>
		</view>
		<view class="price o-flex-r-s-e">
			<text class="unit">¥</text>
			<text class="num">{{(userInfo.qrcodeSource == 1 && userInfo.vipGrade != 0) || item.type == 11 || item.type == 12 ? item.price : item.otPrice}}</text>
			<text class="text">{{(userInfo.qrcodeSource == 1 && userInfo.vipGrade != 0) || item.type == 11 || item.type == 12 ? '会员价' : '零售价'}}</text>
		</view>
		<view class="o-flex-r-s-e"v-if="userInfo.qrcodeSource == 1 && userInfo.vipGrade == 0 && item.type != 11 && item.type != 12">
			<wd-text color="#4C4C4C" size="24rpx" line-height="38rpx" bold text="¥"></wd-text>
			<wd-text color="#4C4C4C" size="32rpx" line-height="44rpx" bold :text="item.price"></wd-text>
			<wd-text color="#4C4C4C" size="24rpx" line-height="44rpx" bold text="会员价"></wd-text>
			<!-- <text class="unit" style="color: #4C4C4C;">¥</text>
			<text class="num text-weight-b" style="color: #4C4C4C;">{{item.price}}</text>
			<text class="text" style="color: #4C4C4C;">会员价</text> -->
		</view>
		<!-- <view class="sales" v-if="item.sales">已售{{formatNumber(item.sales)}}</view> -->
		<view v-if="item?.buyFlag == true" class="car o-flex-r-c-c" @click.stop="getAddr(item.id)">
			<uni-icons fontFamily="iconfont" size="38rpx" color="#FFFFFF">&#xe656;</uni-icons>
		</view>
	</view>
	<view v-if="attrShow" @click.stop>
		<wd-popup v-model="attrShow" position="bottom" custom-style="border-radius: 32rpx 32rpx 0 0;" :z-index="999">
			<specifications :productValue="productValue" :productSelect="productSelect" :type="2"
			:productAttr="productAttr" :attrNumber="attrNumber" @changeAttr="changeAttr"></specifications>
		</wd-popup>
	</view>
</template>

<style lang="scss" scoped>
	.item {
		background: #fff;
		padding: 20rpx;
		box-sizing: border-box;
		word-break: break-all;
		position: relative;
		.label {
			display: inline-block;
			padding: 6rpx 4rpx;
			font-size: 28rpx;
			line-height: 28rpx;
			background: linear-gradient(124deg, #AA93FF 2%, #E83CFF 59%);
			color: #fff;
			border-radius: 4rpx;
			font-weight: 700;
			margin-right: 12rpx;
		}
		.labels {
			margin-top: 12rpx;
			.tag {
				margin-right: 8rpx;
				line-height: 30rpx;
				font-size: 24rpx;
				border-radius: 8rpx;
				padding: 0 6rpx;
			}
		}
		.name {
			margin-top: 12rpx;
			font-size: 28rpx;
			color: #333;
			font-weight: 700;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.price {
			color: #FF6F16;
			margin-top: 12rpx;
			.unit {
				font-size: 24rpx;
				margin-bottom: 2rpx;
			}
			.num {
				font-size: 36rpx;
				font-weight: 700;
			}
			.text {
				font-size: 28rpx;
				margin-bottom: 2rpx;
			}
		}
		.sales {
			margin-top: 12rpx;
			font-size: 28rpx;
			color: #999;
		}
		.car {
			position: absolute;
			width: 68rpx;
			height: 68rpx;
			background: linear-gradient( 92deg, #FD8523 0%, #FD6323 100%);
			border-radius: 68rpx;
			bottom: 16rpx;
			right: 16rpx;
		}
	}
</style>